import React from "react";
import { useDispatch } from "react-redux";
import "./FormTextInput.scss";
import RequiredStar from "../RequiredStar/RequiredStar";
import {
    removeFormFieldError,
    updateFormFieldCustomFieldValidity,
} from "../../redux/actions/contentActions";

const FormTextInput = (props) => {
    const dispatch = useDispatch();

    var pattern = "";
    var maxlength = "";

    if (props.postalCode) {
        pattern = "^[A-Za-z]\d[A-Za-z]\ \d[A-Za-z]\d$";
        maxlength = "7";
    } else if (props.phoneNumber) {
        pattern = "^\d{3}\d{3}\d{4}$";
        maxlength = "10";
    }

    var inputClasses = "form-text-input";
    if (props.full) inputClasses += " full";
    if (props.topPad) inputClasses += " top-padding";

    if (props.conditional) {
        inputClasses += " conditional";

        var condActive = false;
        if (
            typeof props.cond_value !== "undefined" &&
            typeof props.cond_field !== "undefined"
        ) {
            if (Array.isArray(props.cond_value)) {
                for (var i = 0; i < props.cond_value.length; i++) {
                    if (props.cond_value[i] == props.cond_field) {
                        //its conditional and should be shown if we get a match
                        condActive = true;
                    }
                }
            } else {
                if (props.cond_value == props.cond_field) condActive = true;
            }
        }

        if (condActive) {
            inputClasses += " cond_active";
        }
    }

    var errorClasses = "error-label";
    if (props.error) errorClasses += " show";

    function fieldSetIntoValidity(value) {
        if (!props.postalCode && !props.phoneNumber) return true;

        if (props.postalCode) {
            var regex = /^(?:[A-Z]\d[A-Z]\ \d[A-Z]\d)$/i;
            if (value.match(regex)) {
                return true;
            }
        }
        if (props.phoneNumber) {
            var regex = /^\d{3}\d{3}\d{4}$/;
            if (value.match(regex)) {
                return true;
            }
        }

        return false;
    }

    const onTextInputChange = (e) => {
        const value = e.target.value;
        props.setFormValue({ ...props.formValue, [e.target.name]: value });
        if (props.error) {
            if (fieldSetIntoValidity(value)) {
                dispatch(removeFormFieldError(props.index));
            }
        } else {
            if (props.postalCode || props.phoneNumber) {
                var index = props.index;
                var valid = fieldSetIntoValidity(value);

                dispatch(updateFormFieldCustomFieldValidity(index, !valid));
            }
        }
    };

    return (
        <div className={inputClasses}>
            <label htmlFor={props.id}>
                {props.label}
                {props.required && <RequiredStar />}
            </label>
            <input
                type={props.email ? "email" : "text"}
                placeholder={props.placeholder}
                onChange={onTextInputChange}
                name={props.name}
                className={props.error ? "text-input-error" : ""}
                pattern={pattern}
                maxlength={maxlength}
            />
            <span class={errorClasses}>{props.errorText}</span>
        </div>
    );
};

export default FormTextInput;
